import axios from '../assets/axios.wrap';

const contextPath = '/remote';
export function startRecord(data){
    return axios.postByFormUrl(`${contextPath}/record/start`, data);
}
export function stopRecord(data){
    return axios.postByFormUrl(`${contextPath}/record/stop`, data);
}
// 取消
export function cancelRecord(data){
    return axios.postByFormUrl(`${contextPath}/record/cancel`, data);
}
